'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_intelacloud_content_Contact(eyebrow, title, lead, email, topics, needsTitle, interestLabel, interests) {
  this.gF = null;
  this.gK = null;
  this.gI = null;
  this.gE = null;
  this.gL = null;
  this.gJ = null;
  this.gG = null;
  this.gH = null;
  this.gF = eyebrow;
  this.gK = title;
  this.gI = lead;
  this.gE = email;
  this.gL = topics;
  this.gJ = needsTitle;
  this.gG = interestLabel;
  this.gH = interests;
}
export { $c_Lio_intela_sites_intelacloud_content_Contact as $c_Lio_intela_sites_intelacloud_content_Contact };
$p = $c_Lio_intela_sites_intelacloud_content_Contact.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_intelacloud_content_Contact;
/** @constructor */
function $h_Lio_intela_sites_intelacloud_content_Contact() {
}
export { $h_Lio_intela_sites_intelacloud_content_Contact as $h_Lio_intela_sites_intelacloud_content_Contact };
$h_Lio_intela_sites_intelacloud_content_Contact.prototype = $p;
$p.O = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.q = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().V(this, 294068109, true);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lio_intela_sites_intelacloud_content_Contact)) {
    if ((this.gF === x$0.gF)) {
      var x = this.gK;
      var x$2 = x$0.gK;
      var $x_3 = ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      var $x_3 = false;
    }
    if (($x_3 && (this.gI === x$0.gI))) {
      var x$3 = this.gE;
      var x$4 = x$0.gE;
      var $x_2 = ((x$3 === null) ? (x$4 === null) : x$3.f(x$4));
    } else {
      var $x_2 = false;
    }
    if ($x_2) {
      var x$5 = this.gL;
      var x$6 = x$0.gL;
      var $x_1 = ((x$5 === null) ? (x$6 === null) : x$5.f(x$6));
    } else {
      var $x_1 = false;
    }
    if ((($x_1 && (this.gJ === x$0.gJ)) && (this.gG === x$0.gG))) {
      var x$7 = this.gH;
      var x$8 = x$0.gH;
      return ((x$7 === null) ? (x$8 === null) : x$7.f(x$8));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.r = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().U(this);
});
$p.G = (function() {
  return 8;
});
$p.I = (function() {
  return "Contact";
});
$p.H = (function(n) {
  switch (n) {
    case 0: {
      return this.gF;
      break;
    }
    case 1: {
      return this.gK;
      break;
    }
    case 2: {
      return this.gI;
      break;
    }
    case 3: {
      return this.gE;
      break;
    }
    case 4: {
      return this.gL;
      break;
    }
    case 5: {
      return this.gJ;
      break;
    }
    case 6: {
      return this.gG;
      break;
    }
    case 7: {
      return this.gH;
      break;
    }
    default: {
      throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
    }
  }
});
function $isArrayOf_Lio_intela_sites_intelacloud_content_Contact(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.bp)));
}
export { $isArrayOf_Lio_intela_sites_intelacloud_content_Contact as $isArrayOf_Lio_intela_sites_intelacloud_content_Contact };
var $d_Lio_intela_sites_intelacloud_content_Contact = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_intelacloud_content_Contact, "io.intela.sites.intelacloud.content.Contact", ({
  bp: 1,
  b: 1,
  e: 1,
  a: 1
}));
export { $d_Lio_intela_sites_intelacloud_content_Contact as $d_Lio_intela_sites_intelacloud_content_Contact };
//# sourceMappingURL=io.intela.sites.intelacloud.content.-Contact.js.map
